
<template>

  <div class="organ-userCtrl">
    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="16"
            :lg="16"
          >
          <Divider orientation="left">{{langMap.userManagement[lang]}}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="8"
            :lg="8"
          >
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <!-- <FormItem
                :label="langMap.userType[lang]"
                class="leftFlex"
              >
                <Select v-model.trim="searchType">
                  <Option value="0">{{langMap.all[lang]}}</Option>
                  <Option value="1">{{langMap.backendUser[lang]}}</Option>
                </Select>
              </FormItem> -->
              <FormItem
                :label="langMap.keyword[lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="term"
                  clearable
                  :placeholder="langMap.keyword[lang]"
                />
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData"
              >{{langMap.search[lang]}}</Button>
              <Button
                type="primary"
                style="margin-left:20px;"
                @click="changeAddUserModel(true)"
              >{{langMap.addUser[lang]}}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>

      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="userListCol"
        :data="userList"
      ></Table>
      <!--分页数据-->
      <div
        style="text-align:center;padding-top:10px;"
        v-if="userList.length>0"
      >
        <Page
          :current="index"
          :total="total"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>
    </Card>

    <!--添加用户模态框-->
    <Modal
      :mask-closable="false"
      :title="langMap.addUser[lang]"
      v-model="addModal"
      width="500"
    >
      <Form
        ref="addUser"
        :model="addUser"
        :rules="addAdminrules"
        :label-width="100"
      >
        <FormItem
          :label="langMap.account[lang] + ':'"
          prop="code"
        >
          <Input
            type="text"
            v-model="addUser.code"
            :placeholder="langMap.account[lang]"
          />
        </FormItem>
        <FormItem
          :label="langMap.username[lang] + ':'"
          prop="name"
        >
          <Input
            type="text"
            v-model="addUser.name"
            :placeholder="langMap.username[lang]"
          />
        </FormItem>

        <FormItem
          :label="langMap.phoneNumber[lang] + ':'"
          prop="phone"
        >
          <Input
            type="text"
            v-model="addUser.phone"
            :placeholder="langMap.phoneNumber[lang]"
          />
        </FormItem>

        <FormItem
          :label="langMap.email[lang] + ':'"
          prop="email"
        >
          <Input
            type="email"
            v-model="addUser.email"
            :placeholder="langMap.email[lang]"
            autocomplete="new-email"
          />
        </FormItem>

        <FormItem
          :label="langMap.password[lang] + ':'"
          prop="pwd"
        >
          <Input
            type="password"
            v-model.trim="addUser.pwd"
            :placeholder="langMap.password[lang]"
            autocomplete="new-password"
          />
        </FormItem>

      </Form>
      <div slot="footer">
        <Button
          @click="changeAddUserModel(false)"
          style="margin-left: 8px"
        >{{langMap.cancel[lang]}}</Button>
        <Button
          @click="saveUserInfo"
          type="primary"
        >{{langMap.save[lang]}}</Button>
      </div>
    </Modal>

    <!--赋职弹框-->
    <Modal
      :mask-closable="false"
      :title="langMap.giveUserRole[lang]"
      v-model="saveUserRole"
      width="500"
    >
      <Form :label-width="100">
        <FormItem
          :label="langMap.roleName[lang] + ':'"
          vertical
        >
          <div @click="reloadRole">
            <RadioGroup v-model="selectRole">
              <Radio
                v-for="roleItem in userRoleList"
                :key="roleItem.roleId"
                :label="roleItem.roleId"
              >{{roleItem.roleName}}</Radio>
            </RadioGroup>
          </div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="saveUserRole=false">{{langMap.cancel[lang]}}</Button>
        <Button
          type="primary"
          @click="postAddUserRole"
        >{{langMap.confirm[lang]}}</Button>
      </div>
    </Modal>

    <!-- 用户修改 -->
    <Modal
      :title="langMap.modifyInfo[lang]"
      v-model="changeInfoModel"
      width="500"
      :mask-closable="false"
    >
      <Form
        ref="changeInfoRef"
        :model="changeInfoItem"
        :label-width="100"
      >
        <FormItem
          :label="langMap.account[lang] + ':'"
          prop="code"
        >
          <Input
            disabled
            type="text"
            v-model.trim="changeInfoItem.code"
            :placeholder="langMap.account[lang]"
          ></Input>
        </FormItem>
        <FormItem
          :label="langMap.username[lang] + ':'"
          :rules="[{required: true,message:langMap.username[lang]}]"
          prop="name"
        >
          <Input
            type="text"
            v-model.trim="changeInfoItem.name"
            :placeholder="langMap.username[lang]"
          ></Input>
        </FormItem>
        <FormItem
          :label="langMap.phoneNumber[lang] + ':'"
          :rules="[{
							min:11,
							max:11,
							message: langMap.phoneFormatError[lang]
						},{
							pattern: /^[0-9]*$/,
							message: langMap.phoneFormatError[lang]
						},{required: true,message:langMap.phoneNumber[lang]}]"
          prop="phone"
        >
          <Input
            disabled
            type="text"
            v-model.trim="changeInfoItem.phone"
            :placeholder="langMap.username[lang]"
          ></Input>
        </FormItem>

        <FormItem
          :label="langMap.email[lang] + ':'"
          :rules="[
                    {
                      required: true,
                      message: langMap.pleaseInputEmail[this.lang]
                    },
                    {
                      type: 'email',
                      message: langMap.emailFormatError[this.lang]
                    }
                  ]"
          prop="email"
        >
          <Input
            type="email"
            v-model="changeInfoItem.email"
            :placeholder="langMap.email[lang]"
            autocomplete="new-email"
          />
        </FormItem>

        <FormItem
          :label="langMap.password[lang] + ':'"
          prop="showPwd"
        >
          <Input
            type="password"
            v-model.trim="changeInfoItem.showPwd"
            :placeholder="langMap.password[lang]"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          @click="changeInfoModel=false"
          style="margin-left: 8px"
        >{{langMap.cancel[lang]}}</Button>
        <Button
          @click="saveChnageInfo"
          type="primary"
        >{{langMap.save[lang]}}</Button>
      </div>
    </Modal>
    <!-- 应用 -->
    <Modal
      :mask-closable="false"
      v-model="saveUserApplication"
      :title="langMap.application[lang]"
    >
      <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll"
        >{{langMap.all[lang]}}</Checkbox>
      </div>
      <Checkbox-group
        v-model="checkAllGroup"
        @on-change="checkAllGroupChange"
      >
        <Checkbox
          v-for="item in userApplicationList"
          :key="item.id"
          :label="item.id"
        >{{item.name}} [ {{item.serverName}} ] </Checkbox>
      </Checkbox-group>
      <div slot="footer">
        <Button @click="saveUserApplication=false;">{{langMap.cancel[lang]}}</Button>
        <Button
          type="primary"
          @click="postUserApplication"
        >{{langMap.submit[lang]}}</Button>
      </div>
    </Modal>

  </div>

</template>

<script>
//引入md5
var md5 = require("js-md5");
import userInfo from "./userinfo.vue";
import api from "../../../api/index.js";
import moment from "moment";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { validatePassword, createValidator } from '@/utils/validators';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      indeterminate: true,
      checkAll: false,
      checkAllGroup: [],
      tableLoading: false,

      //筛选用户信息
      index: 1,
      term: "",
      searchType: "",
      total: 0,

      //用户列表
      userList: [],

      //添加用户数据
      addUser: {
        phone: "",
        name: "",
        pwd: "",
        code:"",
        email: ""
      },
      addModal: false,

      //用户角色赋值
      saveUserRole: false,
      userRoleList: [],
      selectRole: 0,
      userApplicationList: [],
      saveUserApplication: false,
      //修改用户信息
      changeInfoModel: false,
      cacheUid: 0,
      changeInfoItem: {
        id: "",
        /** 用户名称 */
        name: "",
        email: "",
        /** 用户密码 */
        pwd: "",
        showPwd: ""
      }
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    userListCol() {
      return [
        /*{
              type: 'expand',
              width: 50,
              render: (h, params) => {
                  return h(userInfo, {
                      props: {
                          row: params.row
                      }
                  })
              }
          },*/
        {
          title: "#",
          width: 80,
          type: "index"
        },
        {
          title: langMap.userName[this.lang],
          minWidth: 120,
          key: "name",
          render: (h, params) => {
            return h("span", params.row.name ? params.row.name : this.langMap.none[this.lang]);
          }
        },

        {
          title: langMap.phoneNumber[this.lang],
          minWidth: 120,
          key: "phone"
        },

        /*{
            title: '用户类型',
            key: 'userType',
            render:(h, params)=>{
              if(params.row.userType==1){
                return h('span',"后台用户");
              }
                      }
          },*/
        {
          title: langMap.userRole[this.lang],
          minWidth: 120,
          key: "roleName",
          render: (h, params) => {
            return h(
              "span",
              params.row.roleName ? params.row.roleName : this.langMap.noRole[this.lang]
            );
          }
        },

        {
          title: langMap.createTime[this.lang],
          minWidth: 150,
          key: "createTime"
        },
        /*{
            title: '登录次数',
            key: 'loginNum'
          },
          {
            title: '登录时间',
            key: 'loginTime',
            render:(h, params)=>{
                        if(params.row.loginTime){
                          return h('span',params.row.loginTime)
                        }else{
                          return h('span',"未登录过系统")
                        }
                      }
          },*/
        {
          title: langMap.status[this.lang],
          minWidth: 120,
          key: "state",
          render: (h, params) => {
            if (params.row.state == 1) {
              return h("span", this.langMap.normal[this.lang]);
            } else {
              return h("span", this.langMap.disable[this.lang]);
            }
          }
        },
        {
          title: langMap.operation[this.lang],
          width: 300,
          align: "center",
          render: (h, params) => {
            //禁用启用判断
            var rendText = this.langMap.enable[this.lang];
            var rendStyle = "info";
            if (params.row.state == 1) {
              rendText = this.langMap.disable[this.lang];
              rendStyle = "warning";
            }
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: this.langMap.tip[this.lang],
                        content: this.langMap.confirmModifyUserStatus[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "system-server/user/update/state?id=" +
                              params.row.id,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: this.langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getUserInfoList();
                              }
                              -this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                rendText
              )
            );
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    padding: "2px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.cacheUid = params.row.id;
                      this.getRoleByUid(params.row.id);
                    }
                  }
                },
                langMap.assignRole[this.lang]
              )
            );
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.$Spin.show();
                      api
                        .getData(
                          "system-server/user/get/" + params.row.id,
                          this
                        )
                        .then(res => {
                          if (res.state == 0) {
                            this.$Notice.error({
                              title: this.langMap.tip[this.lang],
                              desc: res.msg
                            });
                          } else {
                            this.$refs.changeInfoRef.resetFields();
                            this.changeInfoItem = { ...res.data };
                            this.changeInfoModel = true;
                          }
                          -this.$Spin.hide();
                        });
                    }
                  }
                },
                langMap.modifyInfo[this.lang]
              )
            );
            return h("div", renderArray);
          }
        }
      ]
    },
    addAdminrules() {
      return {
        phone: [
          {
            required: true,
            message: langMap.pleaseInputPhone[this.lang]
          },
          {
            min: 11,
            max: 11,
            message: langMap.phoneFormatError[this.lang]
          },
          {
            pattern: /^[0-9]*$/,
            message: langMap.phoneInputError[this.lang]
          }
        ],
        name: [
          {
            required: true,
            message: langMap.pleaseInputUsername[this.lang]
          }
        ],
        code: [
          {
            required: true,
            message: langMap.pleaseInputAccount[this.lang]
          }
        ],
        email: [
          {
            required: true,
            message: langMap.pleaseInputEmail[this.lang]
          },
          {
            type: 'email',
            message: langMap.emailFormatError[this.lang]
          }
        ],
        pwd: [
          {
            required: true,
            message: langMap.pleaseInputPassword[this.lang],
          },
          { max: 15, message: langMap.maxFifteenChar[this.lang], trigger: 'blur' },
          { validator: createValidator(validatePassword, this.lang), trigger: "blur" }
        ]
      }
    }
  },
  methods: {
    postUserApplication() {
      var newJson = {
        userId: this.cacheUid,
        aIds: this.checkAllGroup
      };
      //提交菜单数据
      this.$Spin.show();
      api
        .postData("system-server/user/save/user/application", newJson, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.promptFromSystem[this.lang],
              desc: res.msg
            });
          } else {
            this.$Notice.success({
              title: langMap.promptFromSystem[this.lang],
              desc: langMap.operationSuccess[this.lang]
            });
          }
          this.saveUserApplication = false;
          this.$Spin.hide();
        });
    },
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        for (var i = 0; i < this.userApplicationList.length; i++) {
          this.checkAllGroup.push(this.userApplicationList[i].id);
        }
      } else {
        this.checkAllGroup = [];
      }
    },
    checkAllGroupChange(data) {
      if (data.length === this.userApplicationList.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    //用户信息列表
    getUserInfoList() {
      this.tableLoading = true;
      api
        .getData(
          "system-server/user/list?index=" +
            this.index +
            "&term=" +
            this.term +
            "&type=" +
            this.searchType,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.total = res.data.total;
            this.userList = res.data.rows;
          }
          this.tableLoading = false;
        });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getUserInfoList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getUserInfoList();
    },

    //打开或者关闭用户添加模态框
    changeAddUserModel(flag) {
      if (flag) {
        this.$refs.addUser.resetFields();
        this.addModal = flag;
      } else {
        this.addModal = flag;
      }
    },

    //保存用户
    saveUserInfo() {
      this.$refs.addUser.validate(valid => {
        if (valid) {
          var newJson = {
            phone: this.addUser.phone,
            pwd: md5(this.addUser.pwd),
            name: this.addUser.name,
            code: this.addUser.code,
            email: this.addUser.email
          };
          this.$Spin.show();
          api
            .postData("system-server/user/add/admin", newJson, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.tip[this.lang],
                  desc: langMap.saveSuccess[this.lang],
                });
                this.changeAddUserModel(false);
                this.getUserInfoList();
              }
              this.$Spin.hide();
            });
        }
      });
    },

    //获取用户角色列表
    getRoleByUid(uid) {
      this.$Spin.show();
      api.getData("system-server/user/get/role/" + uid, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.promptFromSystem[this.lang],
            desc: res.msg
          });
        } else {
          this.userRoleList = res.data;
          //判断选中角色
          this.selectRole = 0;
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].check) {
              this.selectRole = res.data[i].roleId;
              break;
            }
          }
          this.saveUserRole = true;
        }
        this.$Spin.hide();
      });
    },

    getApplicationByUserId(uid) {
      (this.indeterminate = true),
        (this.checkAll = false),
        (this.checkAllGroup = []);
      this.$Spin.show();
      api
        .getData("system-server/user/get/application/" + uid, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.promptFromSystem[this.lang],
              desc: res.msg
            });
          } else {
            //处理数据
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i].check > 0) {
                this.checkAllGroup.push(res.data[i].id);
              }
            }
            if (this.checkAllGroup.length === res.data.length) {
              this.checkAll = true;
            }
            this.userApplicationList = res.data;
            this.saveUserApplication = true;
          }
          this.$Spin.hide();
        });
    },

    //添加用户角色
    postAddUserRole() {
      var postNesJson = {
        uid: this.cacheUid,
        roleId: this.selectRole
      };
      this.$Spin.show();
      //提交数据
      api
        .postData("system-server/user/set/role", postNesJson, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.promptFromSystem[this.lang],
              desc: res.msg
            });
          } else {
            this.tableData = res.data;
            this.$Notice.success({
              title: langMap.promptFromSystem[this.lang],
              desc: langMap.saveSuccess[this.lang],
            });
          }
          this.$Spin.hide();
          this.saveUserRole = false;
          //列出数据
          this.getUserInfoList();
        });
    },

    //重置用户角色
    reloadRole() {
      if (this.selectRole) {
        this.selectRole = 0;
      }
    },

    //保存修改的用户信息
    saveChnageInfo() {
      this.$refs.changeInfoRef.validate(valid => {
        if (valid) {
          if (this.changeInfoItem.showPwd) {
            //密码md5
            this.changeInfoItem.pwd = md5(this.changeInfoItem.showPwd);
          }

          this.$Spin.show();
          api
            .postData(
              "system-server/user/update/info",
              this.changeInfoItem,
              this
            )
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.tip[this.lang],
                  desc: langMap.saveSuccess[this.lang],
                });
                this.changeInfoModel = false;
                this.getUserInfoList();
              }
              this.$Spin.hide();
            });
        }
      });
    }
  },
  created() {
    this.getUserInfoList();
  }
};
</script>

<style lang="less">
.organ-userCtrl {
  .des-cardTittle-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
.progress-flexBox {
  display: flex;
  .flex-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    font {
      display: block;
    }
  }
  .flex-item:last-child {
    align-items: flex-end;
  }
}
.notActive {
  filter: grayscale(100%);
}
</style>
